<section id="hero" class="container-fluid d-flex align-items-center justify-content-center">
    <div>
        <h2>Hills and Forest</h2>
        <p>You can do shopping, find new jobs, learn Chinese Mandarin and meet our team here.</p>
    </div>
</section>

<style>
    #hero {
		background-color: rgba(35, 64, 41, 0.452);
		color: #FFF;
		height: 50vh;
	}
</style>
